import React from 'react';
import IconAbstract from '../../Lib/Components/IconAbstract';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faChalkboardTeacher} from '@fortawesome/free-solid-svg-icons';
import GenderIconDeterminator from '../../Lib/GenderIconDeterminator';

class TeacherIcon extends IconAbstract {
	renderIcons()
	{
		const { gender } = this.props;

		return (
			<>
				<FontAwesomeIcon icon={faChalkboardTeacher} transform={`down-1`}/>
				<FontAwesomeIcon icon={GenderIconDeterminator.determine( gender )} transform={`shrink-7 up-4 left-11`}/>
			</>
		)
	}
}

export default TeacherIcon;
